import React, { RefObject, useState } from 'react'
import {
  ExCol,
  ExpectedProfitCol,
  FeeCol,
  FilledCol,
  MarketCol,
  PriceCol,
  ProfitCol,
  VolumeCol,
  StatusesCol,
  ItemWrapper,
  TimeCol,
  DeltaCol,
  // Ellipsis,
  // HoverBlock,
  FullValue,
  ShortedValue,
  ColoredBySide,
  ColoredByStatus,
  ColoredByBool,
  YellowSpan,
  ButtonsCol,
  ShowFullButton,
  LogicTypeCol,
  ColoredByLogicType,
  DetailsBlock,
  IconImg,
  GraySpan,
  ColoredByNumber,
} from './TableItem.styled'
import { Action } from '../../../redux/calcBot/types'
import { expNumToString, imageLink, imageLinkToEx, numberToShort } from '../../../utils/utils'
import { calcLogics } from '../../../redux/calcBot'
import { useAppDispatch } from '../../../redux/store'
import { StatButton } from '../../../components/TradeOption/TradeOption'
import { ActionItem } from '../ActionItem'
import { useNavigate } from 'react-router-dom'
import { routes } from '../../../routes/routes'

interface ITableItem extends Action {
  elemRef?: RefObject<HTMLDivElement>
}

export const TableItem: React.FC<ITableItem> = props => {
  const dispatch = useAppDispatch()
  const {
    _id,
    // tradeOptionId,
    filledAmount,
    firstOrder,
    firstDate,
    // secondOrders,
    // secondDate,
    // expectedFirstBalance,
    // expectedSecondBalance,
    createdAt,
    expectedProfit,
    expectedProfitPercent,
    profit,
    // actionOrders,
    tradeOptionInfo,
    logicType,
    // finishedAt,
    firstPrice,
    secondPrice,
    // amount,
    firstFee,
    // firstFeePercent,
    secondFee,
    // secondFeePercent,
    // swapExchanges,
    firstStatus,
    secondStatus,
    // decisionTime,
    // depthTime,
    filterByClickedAction,
    allOrders,
    // securedPrice,
    // feeSum,
    // firstSide,
    elemRef,
  } = props
  const [detailsOpened, setDetailsOpened] = useState(false)
  const navigate = useNavigate()
  if (!createdAt) return <div>BAD ACTION</div>
  const {
    firstEx,
    secondEx,
    market: trOptMarket,
    secondMarket: trOptSecondMarket,
    // market, secondMarket, firstBid, firstAsk, secondBid, secondAsk
  } = tradeOptionInfo[0]

  const firstActionOrder = allOrders && allOrders.length ? allOrders.find(item => item._id.toString() === firstOrder.toString()) : undefined
  const secondActionOrders = allOrders && allOrders.length ? allOrders?.filter(item => item._id.toString() !== firstActionOrder?._id?.toString()) : []
  const firstActionMarket = trOptMarket === trOptSecondMarket ? trOptMarket : firstActionOrder?.market
  const secondActionMarket = secondActionOrders?.length ? allOrders?.find(item => item.exchange !== firstActionOrder?.exchange)?.market : ''

  return (
    <ItemWrapper
      key={_id}
      ref={elemRef}
      onMouseLeave={() => {
        setDetailsOpened(false)
        dispatch(calcLogics.actions.isActionOpen(false))
      }}
      isMarket={logicType === 'MARKET'}
      onClick={() => {
        setDetailsOpened(prev => !prev)
        dispatch(calcLogics.actions.isActionOpen(!detailsOpened))
      }}
    >
      <LogicTypeCol>
        <ColoredByLogicType logicType={logicType}>{logicType === 'LIMIT' ? 'L' : 'M'}</ColoredByLogicType>
      </LogicTypeCol>
      <TimeCol>
        <ShortedValue style={{ justifyContent: 'center' }}>
          <GraySpan>
            {firstDate
              ? new Date(firstDate).toLocaleString('en-GB', {
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false,
                })
              : '--:--:--'}
          </GraySpan>
        </ShortedValue>
        <FullValue style={{ justifyContent: 'center' }}>
          {firstDate
            ? new Date(firstDate).toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false,
              })
            : '--:--:--'}
        </FullValue>
        {/*/<span>{secondDate ? new Date(secondDate).toLocaleTimeString() : '--:--:--'}</span>*/}
      </TimeCol>
      <ButtonsCol>
        <StatButton
          onClick={e => {
            e.stopPropagation()
            if (tradeOptionInfo) {
              dispatch(
                calcLogics.actions.editActionsFilterByExchange({
                  firstEx: tradeOptionInfo[0].firstEx,
                  secondEx: tradeOptionInfo[0].secondEx,
                  market: tradeOptionInfo[0].market,
                  secondMarket:
                    tradeOptionInfo[0].secondMarket && tradeOptionInfo[0].market !== tradeOptionInfo[0].secondMarket
                      ? tradeOptionInfo[0].secondMarket
                      : 'All',
                })
              )
            }
          }}
        >
          Stat
        </StatButton>
      </ButtonsCol>
      <MarketCol>
        <IconImg src={imageLink(trOptMarket?.split('/')[0] || '')} />
        <ShortedValue>
          {/*<GraySpan>{firstActionMarket === secondActionMarket ? firstActionMarket : `${firstActionMarket} ${secondActionMarket}`}</GraySpan>*/}
          <GraySpan>
            {secondActionMarket
              ? firstActionMarket === secondActionMarket
                ? firstActionMarket
                : `${firstActionMarket} ${secondActionMarket}`
              : trOptMarket}
          </GraySpan>
        </ShortedValue>
        <FullValue>
          {secondActionMarket
            ? firstActionMarket === secondActionMarket
              ? firstActionMarket
              : `${firstActionMarket} ${secondActionMarket}`
            : trOptMarket}
        </FullValue>
      </MarketCol>
      <ExCol>
        <FullValue>
          <ColoredBySide style={{ width: '50%' }} side={firstActionOrder?.side}>
            <IconImg src={imageLinkToEx(firstActionOrder?.exchange || '')} />
            {firstActionOrder?.exchange}
          </ColoredBySide>
          <ColoredBySide style={{ width: '50%' }} side={firstActionOrder?.side === 'BUY' ? 'SELL' : 'BUY'}>
            <IconImg src={imageLinkToEx(firstActionOrder?.exchange === firstEx ? secondEx : firstEx || '')} />
            {firstActionOrder?.exchange === firstEx ? secondEx : firstEx}
          </ColoredBySide>
        </FullValue>
        <ShortedValue>
          <GraySpan style={{ width: '50%' }}>
            <IconImg src={imageLinkToEx(firstActionOrder?.exchange || '')} />
            {firstActionOrder?.exchange}
          </GraySpan>{' '}
          <GraySpan style={{ width: '50%' }}>
            <IconImg src={imageLinkToEx(firstActionOrder?.exchange === firstEx ? secondEx : firstEx || '')} />
            {firstActionOrder?.exchange === firstEx ? secondEx : firstEx}
          </GraySpan>
        </ShortedValue>
      </ExCol>
      <VolumeCol>
        <FullValue>{(filledAmount * (firstActionOrder?.price || 0)).toFixed(2)}</FullValue>
        <ShortedValue>
          <GraySpan>{(filledAmount * (firstActionOrder?.price || 0)).toFixed(2)}</GraySpan>
        </ShortedValue>
      </VolumeCol>
      <PriceCol>
        <FullValue>
          <ColoredBySide style={{ width: '50%' }} side={firstActionOrder?.side}>
            {expNumToString(firstPrice || 0)}
          </ColoredBySide>{' '}
          <ColoredBySide style={{ width: '50%' }} side={firstActionOrder?.side === 'BUY' ? 'SELL' : 'BUY'}>
            {expNumToString(secondPrice || 0)}
          </ColoredBySide>
        </FullValue>
        <ShortedValue>
          <GraySpan style={{ width: '50%' }}>{expNumToString(firstPrice || 0)}</GraySpan>{' '}
          <GraySpan style={{ width: '50%' }}>{expNumToString(secondPrice || 0)}</GraySpan>
        </ShortedValue>
      </PriceCol>
      <FilledCol
        filledPercent={
          Number(
            (((secondActionOrders.length ? secondActionOrders.reduce((acc, item) => item.filled + acc, 0) : 0) / filledAmount) * 100).toFixed(2)
          ) || 0
        }
      >
        {/*<Ellipsis>{expNumToString(filledAmount || 0)}</Ellipsis> /{' '}*/}
        <FullValue style={{ justifyContent: 'center' }}>
          {secondActionOrders.length ? expNumToString(secondActionOrders.reduce((acc, item) => item.filled + acc, 0)) : 0}{' '}
          {firstActionOrder?.market.split('/')[0]}
        </FullValue>
        <ShortedValue style={{ justifyContent: 'center' }}>
          <GraySpan>
            {(((secondActionOrders.length ? secondActionOrders.reduce((acc, item) => item.filled + acc, 0) : 0) / filledAmount) * 100).toFixed(2)}%
          </GraySpan>
        </ShortedValue>
      </FilledCol>
      <StatusesCol>
        {[firstStatus, secondStatus].every(item => item === 'done') ? (
          <ColoredByStatus status={'done'}>done</ColoredByStatus>
        ) : (
          <>
            <ColoredByStatus status={firstStatus}>{firstStatus}</ColoredByStatus>/
            <ColoredByStatus status={secondStatus}>{secondStatus}</ColoredByStatus>
          </>
        )}
      </StatusesCol>

      <ExpectedProfitCol>
        <FullValue>
          <span>
            <ColoredByBool isGood={expectedProfit > 0}>{expectedProfit ? `${numberToShort(+expectedProfit.toFixed(6))}` : '---'} </ColoredByBool>{' '}
            <span>({+(expectedProfitPercent || 0).toFixed(2)}%)</span>
          </span>
        </FullValue>
        <ShortedValue>
          <span>
            <ColoredByBool gray={true} isGood={expectedProfit > 0}>
              {expectedProfit ? `${numberToShort(+expectedProfit.toFixed(2))}` : '---'} <span>({+(expectedProfitPercent || 0).toFixed(2)}%)</span>
            </ColoredByBool>{' '}
          </span>
        </ShortedValue>
      </ExpectedProfitCol>
      <ProfitCol>
        <FullValue>
          <ColoredByBool isGood={profit > 0}>{profit ? `${numberToShort(+profit.toFixed(6))}` : '--- '}</ColoredByBool>
        </FullValue>
        <ShortedValue>
          <ColoredByBool gray={true} isGood={profit > 0}>
            {profit ? `${numberToShort(+profit.toFixed(2))}` : '--- '}
          </ColoredByBool>
        </ShortedValue>
      </ProfitCol>
      <DeltaCol>
        <FullValue>
          <ColoredByBool isGood={((profit - expectedProfit) / Math.abs(expectedProfit)) * 100 >= 0}>
            {expectedProfit && profit ? `${numberToShort(+(((profit - expectedProfit) / Math.abs(expectedProfit)) * 100).toFixed(2))} %` : '---'}
          </ColoredByBool>
        </FullValue>
        <ShortedValue>
          <ColoredByNumber num={((profit - expectedProfit) / Math.abs(expectedProfit)) * 100}>
            {expectedProfit && profit ? `${numberToShort(+(((profit - expectedProfit) / Math.abs(expectedProfit)) * 100).toFixed(2))} %` : '---'}
          </ColoredByNumber>
        </ShortedValue>
      </DeltaCol>
      <FeeCol>
        <FullValue>
          <YellowSpan>{`${((firstFee || 0) + (secondFee || 0))?.toFixed(4) || '-'}`} </YellowSpan>
        </FullValue>
        <ShortedValue>
          <ColoredByBool gray={true} isGood={true}>
            {`${((firstFee || 0) + (secondFee || 0))?.toFixed(2) || '-'}`}{' '}
          </ColoredByBool>
        </ShortedValue>
      </FeeCol>
      <ProfitCol>
        <FullValue>
          <ColoredByBool isGood={profit - (firstFee || 0) - (secondFee || 0) > 0}>
            {profit ? `${numberToShort(+(profit - (firstFee || 0) - (secondFee || 0)).toFixed(6))}` : '---'}
          </ColoredByBool>
        </FullValue>
        <ShortedValue>
          <ColoredByBool isGood={profit - (firstFee || 0) - (secondFee || 0) > 0}>
            {profit ? `${numberToShort(+(profit - (firstFee || 0) - (secondFee || 0)).toFixed(2))}` : '---'}
          </ColoredByBool>
        </ShortedValue>
      </ProfitCol>

      {detailsOpened && (
        <DetailsBlock>
          <ActionItem {...props} key={_id} filterByClickedAction={filterByClickedAction} />
        </DetailsBlock>
      )}
    </ItemWrapper>
  )
}
